export { default } from "./FolderTabsContainer";
